module.exports = "<router-outlet></router-outlet>\n<ad-sense></ad-sense>";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/root/root.component.html
// module id = 602
// module chunks = 0